import { render } from "./DropDownLoadFile.vue?vue&type=template&id=08886823&scoped=true&ts=true"
import script from "./DropDownLoadFile.vue?vue&type=script&lang=ts"
export * from "./DropDownLoadFile.vue?vue&type=script&lang=ts"

import "./DropDownLoadFile.vue?vue&type=style&index=0&id=08886823&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08886823"]])

export default __exports__